/**
 * Retient le chargement des couches de vélocité, le temps d'une séance.
 *
 * # Pourquoi
 *
 * En stratégie `lazy`, une couche entière — trente fichiers à récupérer,
 * décoder et monter — part à la première note dont la nuance n'a pas encore la
 * sienne. En solo c'est le bon moment : on l'entend à peine. En séance c'est
 * le pire : ce travail tombe sur le fil principal pendant qu'on joue, et le
 * fil principal est ce que le gestionnaire MIDI et celui des trames reçues
 * attendent tous les deux. Une couche qui se monte au milieu d'un accord,
 * c'est une salve de notes en retard des deux côtés.
 *
 * Tant qu'une retenue est posée, le synthé joue avec les couches qu'il a — la
 * plus proche en nuance — et n'en monte aucune. Les retenues se comptent : deux
 * séances de suite, ou une séance et un autre appelant, ne se libèrent pas
 * l'une l'autre. Séparé du synthé pour se lire et s'éprouver sans Tone.
 */

let holds = 0;

/** Pose une retenue. Rend de quoi la lever, une seule fois. */
export function holdSamplerLayers(): () => void {
  holds += 1;
  let released = false;

  return () => {
    if (released) {
      return;
    }

    released = true;
    holds -= 1;
  };
}

/** Vrai tant qu'au moins une retenue est posée. */
export function samplerLayersHeld(): boolean {
  return holds > 0;
}
